/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { ENVIRONMENT } from 'config';

export const API = {
  POST_CHAT: {
    path: '/llm/chat',
    method: 'POST',
    baseURL: ENVIRONMENT.BACKEND_API?.replace(/\/api\/v1\/?$/, ''),
  },
};

export const baseUrls = {
  "summary": "seg=ch0&bok=otb&alm=0&sym=1&pms=0&htl=65c1feca069d720e0c8a94a6&sty=20250226-20250226&cmp=py&bpv=rms&bph=14&exf=0&syD=0&load=PA1,RV1,CX0&fct=1&cph=65c1feca069d720e0c8a94a6&nor=0&cur=USD",
  "dashboard": "bok=otb&alm=0&sym=1&pms=0&htl=65c1feca069d720e0c8a94a6&sty=20250226-20250226&cmp=py&syD=0&load=D11,D21,D31&nor=0&cph=65c1feca069d720e0c8a94a6&dtp=ARRIVAL&cur=USD&rpl=0",
  "trend": "bok=otb&alm=0&wkk=0&cum=0&sym=1&pms=0&htl=65c1feca069d720e0c8a94a6&sty=20250101-20250131&cmp=py&tbv=0&seg=ch0&fcs=EMPTY&setA=&setB=&nor=0&cph=65c1feca069d720e0c8a94a6&atb=Trend-Time&load=A1,B1,C1,D0,E0,F0&fct=0&syD=0&bdt=0&pct=0&mov=030&cur=USD&swb=0",
  "pace": "pms=0&htl=65c1feca069d720e0c8a94a6&sty=20250226-20250226&bok=20150101-20250305&bph=14&lag=0&cum=1&seg=ch0&fcs=EMPTY&alm=0&sym=1&per=25&cmp=py&syD=0&bdt=0&atb=Pace-Time-Widget&load=A1,B1,C1,F0,H0&fct=0&bpw=BPH&cph=65c1feca069d720e0c8a94a6&nor=0&tbv=0&cur=USD",
  "regional_map": "seg=ch0&bok=otb&pms=0&htl=65c1feca069d720e0c8a94a6&sty=20250226-20250226&fcs=EMPTY&tbv=G0&cur=USD",
}
export const tabMappings = {
    td: baseUrls.trend,
    pa: baseUrls.pace,
    wb: baseUrls.dashboard,
    sm: baseUrls.summary,
    rm: baseUrls.regional_map
};
export const tabFragments = {
  td: "#trend",
  pa: "#pace",
  wb: "#workbook",
  sm: "#summary",
  rm: "#regional-map"
};
export const nodeNameMap = {
  "ReplyNode": "Generating Reply",
  "ExecuteSQLNode": "Executing Query",
  "IdentifyCommandNode": "Generating UI Change Commands",
  "FixSQLNode": "Fixing Query",
  "NlToSQLNode": "Building Query",
};

 export const segEnum = ['ch', 'ms', 'rc', 'rg', 'ci'];
 export const dateEnum = ['otb', 'lw', 'wtd', 'lm', 'mtd', 'ly', 'ytd', 'tw', 'tm', 'tdy', 'fw7', 'ty'];
 export const cmpEnum = ['otb', 'pw', 'pm', 'py', 'cus'];

 export const targetComponents = {
   'Primary Hotel Dropdown': '.primary-hotel-dropdown',
   'Add/Edit Hotel Set': '.add-hotel',
   'Summary Tab': '.summary',
   'Dashboard Tab': '.dashboard',
   'Trend Tab': '.trend',
   'Pace Tab': '.pace',
   'Reginal Map Tab': '.regional-map',
   Account: '.account',
   'Currency Dropdown': '.currency',
 };